(function () {
  const qs = (s, r) => (r || document).querySelector(s);
  const qsa = (s, r) => Array.from((r || document).querySelectorAll(s));

  const drawer = qs("[data-ke-drawer]");
  const openBtn = qs("[data-ke-menu-open]");
  const closeBtn = qs("[data-ke-menu-close]");
  if (openBtn && drawer) {
    openBtn.addEventListener("click", () => drawer.hidden = false);
  }
  if (closeBtn && drawer) {
    closeBtn.addEventListener("click", () => drawer.hidden = true);
    drawer.addEventListener("click", (e) => {
      if (e.target === drawer) drawer.hidden = true;
    });
  }

  qsa("[data-ke-tabs]").forEach((root) => {
    const buttons = qsa("[data-tab]", root);
    const panels = qsa("[data-panel]", root);
    buttons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const id = btn.getAttribute("data-tab");
        buttons.forEach((b) => b.classList.toggle("is-on", b === btn));
        panels.forEach((p) => p.classList.toggle("is-on", p.getAttribute("data-panel") === id));
      });
    });
  });

  const gallery = qs("[data-ke-gallery]");
  if (gallery) {
    const main = qs("[data-ke-main]", gallery);
    qsa("[data-ke-thumb]", gallery).forEach((btn) => {
      btn.addEventListener("click", () => {
        qsa("[data-ke-thumb]", gallery).forEach((b) => b.classList.remove("is-on"));
        btn.classList.add("is-on");
        if (main) main.src = btn.getAttribute("data-src");
      });
    });
  }

  qsa("[data-ke-trial-strip]").forEach((strip) => {
    const wrap = strip.parentElement;
    const prev = wrap.querySelector("[data-ke-trial-prev]");
    const next = wrap.querySelector("[data-ke-trial-next]");
    const amount = 380;
    if (prev) prev.addEventListener("click", () => strip.scrollBy({ left: -amount, behavior: "smooth" }));
    if (next) next.addEventListener("click", () => strip.scrollBy({ left: amount, behavior: "smooth" }));
  });

  const form = qs("[data-ke-product-form]");
  if (form) {
    const select = qs("[data-ke-variant]", form);
    const priceEl = qs("[data-ke-price]");
    const compareEl = qs("[data-ke-compare]");
    const qty = qs("[data-ke-qty]", form);
    const packs = qsa("[data-ke-pack]", form);
    qsa("[data-ke-qty-btn]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const n = parseInt(qty.value || "1", 10) + Number(btn.getAttribute("data-ke-qty-btn"));
        qty.value = String(Math.max(1, n));
      });
    });
    packs.forEach((btn) => {
      btn.addEventListener("click", () => {
        packs.forEach((b) => b.classList.remove("is-on"));
        btn.classList.add("is-on");
        if (qty) qty.value = btn.getAttribute("data-qty") || "1";
        if (priceEl) priceEl.textContent = btn.getAttribute("data-price") || priceEl.textContent;
        if (compareEl) {
          const c = btn.getAttribute("data-compare");
          compareEl.hidden = !c;
          if (c) compareEl.textContent = c;
        }
      });
    });
    qsa("[data-ke-swatch]").forEach((btn) => {
      btn.addEventListener("click", () => {
        qsa("[data-ke-swatch]").forEach((b) => b.classList.remove("is-on"));
        btn.classList.add("is-on");
        const id = btn.getAttribute("data-id");
        if (select) select.value = id;
        const img = btn.getAttribute("data-image");
        if (img && qs("[data-ke-main]")) qs("[data-ke-main]").src = img;
      });
    });
  }
})();
